exports = module.exports = require("../../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video_poster_20Y9MHCj {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 20;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n}", ""]);

// exports
exports.locals = {
	"video_poster": "video_poster_20Y9MHCj"
};